import { motion } from "framer-motion";
import { Star } from "lucide-react";
import { WHATSAPP_URL } from "@/lib/constants";
import { useLanguage } from "@/lib/i18n";

const EASE = [0.22, 1, 0.36, 1];

const REVIEWS = [
  {
    quote:
      "Sono stati super gentilissimi facendomi fare il check-in prima e fornendomi una casa comoda da arrivarci, pulita e super fornita di qualsiasi cosa.",
    name: "Matteo",
  },
  {
    quote:
      "Sono stata due notti in questo fantastico appartamento, posizione strategica e comoda da raggiungere; la sera cala un silenzio assordante che ti lascia dormire senza alcun disturbo. Appartamento piccolo ma con tutto il necessario per stare bene. Il bagno è il punto forte: elegante, luminoso e accogliente. Paola e il marito, persone super cordiali e disponibili. Se cercate un alloggio in zona Monza Brianza, scegliete loro!",
    name: "Matilde",
  },
  {
    quote:
      "Ho soggiornato qualche giorno nella casa di Paola e mi sono trovato benissimo: lei è molto gentile e disponibile. La casa è accogliente e ha tutto quello che serve, zona molto silenziosa, perfetta per chi cerca un po' di tranquillità! Consiglio a tutti di prenotare il suo appartamento!",
    name: "Francesco",
  },
];

export default function Reviews() {
  const { t } = useLanguage();

  return (
    <section id="recensioni" data-testid="reviews-section" className="py-20 lg:py-28 bg-sand/40">
      <div className="px-4 sm:px-8 lg:px-16 max-w-7xl mx-auto">
        <div className="flex flex-wrap items-end justify-between gap-6 mb-12">
          <div>
            <motion.p
              initial={{ opacity: 0, y: 12 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.7, ease: EASE }}
              className="font-mono-label text-[11px] uppercase tracking-[0.3em] text-terracotta font-bold mb-4"
            >
              {t.reviews.overline}
            </motion.p>
            <motion.h2
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.8, delay: 0.1, ease: EASE }}
              className="font-serif text-3xl sm:text-4xl lg:text-5xl font-medium tracking-tight text-ink text-balance"
            >
              {t.reviews.titleA} <em className="text-terracotta">{t.reviews.titleEm}</em> {t.reviews.titleB}
            </motion.h2>
          </div>
          <motion.a
            data-testid="reviews-whatsapp-btn"
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="font-mono-label text-[11px] uppercase tracking-[0.2em] text-clay hover:text-terracotta transition-colors underline underline-offset-4 decoration-terracotta/40"
          >
            {t.reviews.cta}
          </motion.a>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-5">
          {REVIEWS.map((review, i) => (
            <motion.figure
              key={review.name}
              data-testid={`review-card-${i}`}
              initial={{ opacity: 0, y: 28 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: i * 0.12, ease: EASE }}
              whileHover={{ y: -6 }}
              className="rounded-2xl bg-white border border-[#E2DCD5] p-7 flex flex-col shadow-sm hover:shadow-xl hover:shadow-ink/5 hover:border-terracotta/40 transition-shadow duration-300"
            >
              <div className="flex gap-1 mb-5" aria-label={t.reviews.ratingLabel}>
                {[...Array(5)].map((_, s) => (
                  <Star key={s} className="w-4 h-4 fill-terracotta text-terracotta" />
                ))}
              </div>
              <blockquote className="font-serif italic text-lg leading-relaxed text-ink flex-1">
                "{review.quote}"
              </blockquote>
              <figcaption className="mt-6 pt-4 border-t border-[#E2DCD5]">
                <p className="text-sm font-bold text-ink">{review.name}</p>
                <p className="font-mono-label text-[10px] uppercase tracking-[0.2em] text-clay mt-1">
                  {t.reviews.details[i]}
                </p>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
